import {
  gql 
} from "@apollo/client";

export const DiscountSummaryFragment = gql`
    fragment DiscountSummaryFragment on CartPrices {
        discounts {
            amount {
                currency
                value
            }
            label
        }
        discount {
            amount {
                currency
                value
            }
            label
        }
    }
`;
